export const SM_SCREEN_MIN = 0;
export const SM_SCREEN_MAX = 768;
export const MD_SCREEN_MIN = 769;
export const MD_SCREEN_MAX = 991;
export const LG_SCREEN_MIN = 992;
